import { ReactSVG } from "react-svg";
import React, { InputHTMLAttributes, Ref } from "react";
import { TailSpin } from "react-loader-spinner";

type BaseInputProps = {
  labelStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  errorStyle?: React.CSSProperties;
  error?: any;
  label?: string;
  formik?: any;
  loading?: boolean;
  leftIcon?: ReactSVG;
  name?: string;
  ref?: Ref<HTMLInputElement>;
};
export const BaseInput = ({
  labelStyle,
  inputStyle,
  errorStyle,
  formik,
  name = "",
  // leftIcon,
  // style,
  // error,
  label,
  loading,
  ...props
}: BaseInputProps & InputHTMLAttributes<HTMLInputElement>) => {
  errorStyle = errorStyle ? errorStyle : {};
  inputStyle = inputStyle ? inputStyle : {};
  if (formik?.errors[name] && formik?.touched[name])
    inputStyle["borderColor"] = errorStyle["color"];

  function getFirstElement<M>(n: M[]) {
    return n[0];
  }

  const bbb = [1, 2, 3, 4, 5];
  const ccc = ["a", "b", "c", "d"];

  getFirstElement(bbb);
  getFirstElement(ccc);

  return (
    <>
      <label style={labelStyle} htmlFor={props.id}>
        {label}
      </label>
      {props.type === "submit" && loading && (
        <p style={{ margin: "auto", marginTop: "1.5rem" }}>
          <TailSpin
            visible={true}
            height={30}
            width={30}
            color="#750505"
            ariaLabel="tail-spin-loading"
            strokeWidth={5}
            wrapperStyle={{}}
            wrapperClass=""
          />
        </p>
      )}
      {!(props.type === "submit" && loading) && (
        <input
          id={name}
          value={formik?.values[name]}
          onBlur={formik?.handleBlur(name)}
          onChange={formik?.handleChange(name)}
          style={{ ...inputStyle }}
          {...props}
        />
      )}

      {formik?.touched[name] && (
        <p style={{ color: "red", fontSize: "1.2rem" }}>
          {" "}
          {formik?.errors[name]}{" "}
        </p>
      )}
    </>
  );
};
